import { Provider } from '@angular/core';
import { TickersDataHttpService } from './abstract';
import { TickersDataHttpServiceImpl } from './tickers-data-http.service';

export const TickersDataHttpProvider: Provider = {
	provide: TickersDataHttpService,
	useClass: TickersDataHttpServiceImpl,
};
